<template>
	<div class='knd-table knd-table-aandeel wrap wrap--620'>
		<h4>Top 25 - gemeenten met grootste aandeel gekochte tweede woningen</h4>
		<div id='datatable'></div>
	</div>
</template>

<script>
	import tableData from '@/assets/aandeel_gemeente_2020.csv';
	import "gridjs/dist/theme/mermaid.css";


	import '@/scss/index.scss'

	import { Grid, h, createRef as gCreateRef } from "gridjs";

	import Chartist from 'chartist';

export default {

	name: 'index',

	data () {
		return {

		}
	},

	mounted: function() {
		const opts = {
			height: '30px',
			showPoint: false,
			seriesBarDistance: 5,
			fullWidth:true,
			chartPadding: {top: 5,right: 0,bottom: 5,left: 0},
			axisX: {showGrid: false, showLabel: false, offset: 0},
			axisY: {showGrid: false, showLabel: false, offset: 0}
		};

		new Grid({ 
		columns: [
			{
				data: (row) => { return `${row.GEMEENTE}`},
				name: 'Gemeente'
			},
			{
				id: '2020',
				name: '2020',
				formatter: (cell) => { return `${cell}%` },

			},
		],
		fixedHeader: true,
			sort: true,
			height: '450px',
			data: tableData
		})
		.render(document.getElementById('datatable'));

	}
}
</script>